import React from 'react';
import { Chat } from 'react-bootstrap-icons';

function FloatingFeedbackButton({ isOpen, onClick }) {
    return (
        <button
            className={`floating-feedback${isOpen ? ' floating-feedback--selected' : ''}`}
            onClick={onClick}
            aria-label="Open feedback form"
            aria-haspopup="dialog"
            aria-pressed={isOpen}
        >
            <Chat className="svg-16" />
            Feedback
        </button>
    );
}

export default FloatingFeedbackButton;
